(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rugsone-3d-rug-studio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
    const unique = (values) => [...new Set(values.filter(Boolean))];

    function rectify(image) {
      const canvas = document.createElement('canvas');
      canvas.width = 640;
      canvas.height = 920;
      const ctx = canvas.getContext('2d');
      if (!ctx) return null;
      const back = 520 / 1200;
      const front = 1190 / 1200;
      const k = front / back - 1;
      const source = (u, v) => {
        const d = 1 + k * (1 - v);
        return {
          x: ((.00417 + front * u + ((.29167 * (1 + k)) - .00417) * (1 - v)) / d) * image.naturalWidth,
          y: ((.9375 + ((.5525 * (1 + k)) - .9375) * (1 - v)) / d) * image.naturalHeight
        };
      };
      const drawTriangle = (a, b, c) => {
        const den = a.s.x * (b.s.y - c.s.y) + b.s.x * (c.s.y - a.s.y) + c.s.x * (a.s.y - b.s.y);
        if (Math.abs(den) < .001) return;
        const x = [a.d.x, b.d.x, c.d.x], y = [a.d.y, b.d.y, c.d.y];
        const sx = [a.s.x, b.s.x, c.s.x], sy = [a.s.y, b.s.y, c.s.y];
        const A = (x[0]*(sy[1]-sy[2]) + x[1]*(sy[2]-sy[0]) + x[2]*(sy[0]-sy[1])) / den;
        const B = (y[0]*(sy[1]-sy[2]) + y[1]*(sy[2]-sy[0]) + y[2]*(sy[0]-sy[1])) / den;
        const C = (x[0]*(sx[2]-sx[1]) + x[1]*(sx[0]-sx[2]) + x[2]*(sx[1]-sx[0])) / den;
        const D = (y[0]*(sx[2]-sx[1]) + y[1]*(sx[0]-sx[2]) + y[2]*(sx[1]-sx[0])) / den;
        const E = (x[0]*(sx[1]*sy[2]-sx[2]*sy[1]) + x[1]*(sx[2]*sy[0]-sx[0]*sy[2]) + x[2]*(sx[0]*sy[1]-sx[1]*sy[0])) / den;
        const F = (y[0]*(sx[1]*sy[2]-sx[2]*sy[1]) + y[1]*(sx[2]*sy[0]-sx[0]*sy[2]) + y[2]*(sx[0]*sy[1]-sx[1]*sy[0])) / den;
        ctx.save();
        ctx.beginPath(); ctx.moveTo(x[0], y[0]); ctx.lineTo(x[1], y[1]); ctx.lineTo(x[2], y[2]); ctx.closePath(); ctx.clip();
        ctx.setTransform(A, B, C, D, E, F);
        ctx.drawImage(image, 0, 0);
        ctx.restore();
      };
      const cols = 16, rows = 22;
      for (let row = 0; row < rows; row++) for (let col = 0; col < cols; col++) {
        const point = (u, v) => ({ s: source(u, v), d: { x: u * canvas.width, y: v * canvas.height } });
        const a = point(col / cols, row / rows), b = point((col + 1) / cols, row / rows);
        const c = point((col + 1) / cols, (row + 1) / rows), d = point(col / cols, (row + 1) / rows);
        drawTriangle(a, b, c); drawTriangle(a, c, d);
      }
      return canvas.toDataURL('image/webp', .88);
    }

    function init(root) {
      if (root.dataset.rsReady === 'true') return;
      root.dataset.rsReady = 'true';
      const nodes = [...root.querySelectorAll('[data-rs-variant]')];
      if (!nodes.length) return;
      const variants = nodes.map(n => ({
        id: n.dataset.id,
        options: [n.dataset.option1, n.dataset.option2, n.dataset.option3],
        price: n.dataset.price,
        available: n.dataset.available === 'true',
        image: n.dataset.image,
        url: n.dataset.url
      }));
      let names = [];
      try { names = JSON.parse(root.dataset.optionNames || '[]'); } catch (_) {}
      const active = [0, 1, 2].filter(i => variants.some(v => v.options[i]));
      const namedSize = active.find(i => /size|dimension|measurement|length|width/i.test(names[i] || ''));
      const measuredSize = active.find(i => variants.some(v => /\d+\s*(?:x|×|by)\s*\d+|\d+\s*(?:cm|mm|ft|inch)/i.test(v.options[i] || '')));
      let sizeIndex = namedSize ?? measuredSize ?? (active.includes(Number(root.dataset.sizeIndex) - 1) ? Number(root.dataset.sizeIndex) - 1 : active[0] ?? -1);
      let colourIndex = active.find(i => i !== sizeIndex && /colou?r|shade|pattern|design/i.test(names[i] || ''));
      if (colourIndex === undefined) colourIndex = active.includes(Number(root.dataset.colourIndex) - 1) && Number(root.dataset.colourIndex) - 1 !== sizeIndex ? Number(root.dataset.colourIndex) - 1 : active.find(i => i !== sizeIndex) ?? -1;
      const colourOf = v => colourIndex < 0 ? '' : (v.options[colourIndex] || '');
      const sizeOf = v => sizeIndex < 0 ? '' : (v.options[sizeIndex] || '');
      const swatchSettings = [...root.querySelectorAll('[data-rs-swatch]')].map(n => n.dataset);
      const swatches = root.querySelector('[data-rs-swatches]');
      const sizeSelect = root.querySelector('[data-rs-size]');
      const price = root.querySelector('[data-rs-price]');
      const shop = root.querySelector('[data-rs-shop]');
      const rug = root.querySelector('.rs-rug');
      const loading = root.querySelector('[data-rs-loading]');
      const shade = root.querySelector('[data-rs-colour-name]');
      const viewerVariant = root.querySelector('[data-rs-viewer-variant]');
      const colours = unique(variants.map(colourOf));
      if (!colours.length) colours.push('');
      root.querySelector('[data-rs-colour-option]').hidden = colourIndex < 0;
      root.querySelector('[data-rs-size-option]').hidden = sizeIndex < 0;
      const preferredColour = (root.dataset.startColour || '').toLowerCase();
      let colour = colours.find(x => x.toLowerCase().includes(preferredColour)) || colours[0];
      let size = '';
      let yaw = -12, tilt = 58, zoom = 1, spin = false, top = false, token = 0, animation = 0;
      const cache = new Map();
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const appearance = value => swatchSettings.find(s => value.toLowerCase() === (s.match || '').toLowerCase()) || swatchSettings.find(s => value.toLowerCase().includes((s.match || '~~~').toLowerCase())) || {};
      const renderView = () => { rug.style.transform = `perspective(850px) rotateX(${tilt}deg) rotateZ(${yaw}deg) scale(${zoom})`; };
      const stopSpin = () => { spin = false; cancelAnimationFrame(animation); const button = root.querySelector('[data-rs-action="spin"]'); button.setAttribute('aria-pressed', 'false'); button.textContent = '▶'; };
      const setImage = url => {
        token++;
        const current = token;
        loading.hidden = false;
        if (!url) { loading.hidden = true; return; }
        if (cache.has(url)) { rug.style.backgroundImage = `url("${cache.get(url)}")`; loading.hidden = true; return; }
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => {
          if (current !== token) return;
          let texture = url;
          if (root.dataset.crop === 'true' && /comfy/i.test(root.querySelector('.rs-product-heading h3')?.textContent || '')) {
            try { texture = rectify(image) || url; } catch (_) { texture = url; }
          }
          cache.set(url, texture);
          rug.style.backgroundImage = `url("${texture}")`;
          loading.hidden = true;
        };
        image.onerror = () => { if (current === token) { rug.style.backgroundImage = `url("${url}")`; loading.hidden = true; } };
        image.src = url;
      };
      const renderProduct = () => {
        const selected = variants.find(v => colourOf(v) === colour && sizeOf(v) === size) || variants.find(v => colourOf(v) === colour) || variants[0];
        if (!selected) return;
        price.textContent = selected.price;
        shop.href = selected.url;
        shop.setAttribute('aria-disabled', String(!selected.available));
        shade.textContent = appearance(colour).label || colour;
        viewerVariant.textContent = [appearance(colour).label || colour, size].filter(Boolean).join(' / ').toUpperCase() || selected.id;
        if (rug.dataset.image !== selected.image) { rug.dataset.image = selected.image || ''; setImage(selected.image); }
        const match = size.match(/(\d+)\s*[x×]\s*(\d+)/i);
        if (match) {
          const w = Number(match[1]), h = Number(match[2]);
          rug.style.width = `${clamp((window.innerWidth < 700 ? 230 : 310) * Math.pow(w / 160, .38), 190, 370)}px`;
          rug.style.aspectRatio = `${w} / ${h}`;
        }
      };
      const renderSizes = () => {
        const choices = unique(variants.filter(v => colourOf(v) === colour).map(sizeOf));
        if (!choices.length) choices.push('');
        sizeSelect.replaceChildren();
        choices.forEach(value => {
          const v = variants.find(item => colourOf(item) === colour && sizeOf(item) === value);
          const option = document.createElement('option');
          option.value = value; option.textContent = `${value}${v && !v.available ? ' — Unavailable' : ''}`;
          option.disabled = !!v && !v.available;
          sizeSelect.appendChild(option);
        });
        if (!choices.includes(size) || sizeSelect.querySelector(`option:checked`)?.disabled) {
          size = choices.find(value => variants.some(v => colourOf(v) === colour && sizeOf(v) === value && v.available)) || choices[0];
        }
        sizeSelect.value = size;
        renderProduct();
      };
      const renderSwatches = () => {
        swatches.replaceChildren();
        colours.forEach(value => {
          const style = appearance(value);
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'rs-swatch';
          button.setAttribute('aria-label', style.label || value);
          button.setAttribute('aria-pressed', String(value === colour));
          const circle = document.createElement('i');
          circle.style.setProperty('--rs-swatch', style.hex || '#d8d4c9');
          const label = document.createElement('span'); label.textContent = style.label || value.split('-')[0].trim();
          button.append(circle, label);
          button.addEventListener('click', () => { colour = value; size = ''; renderSwatches(); renderSizes(); });
          swatches.appendChild(button);
        });
      };
      size = unique(variants.filter(v => colourOf(v) === colour).map(sizeOf)).find(v => v.toLowerCase().includes((root.dataset.startSize || '').toLowerCase())) || '';
      renderSwatches(); renderSizes(); renderView();
      sizeSelect.addEventListener('change', () => { size = sizeSelect.value; renderProduct(); });

      let pointer = null;
      rug.addEventListener('pointerdown', e => { pointer = { x: e.clientX, y: e.clientY }; rug.setPointerCapture(e.pointerId); stopSpin(); });
      rug.addEventListener('pointermove', e => { if (!pointer) return; yaw += (e.clientX - pointer.x) * .35; tilt = clamp(tilt - (e.clientY - pointer.y) * .18, 0, 78); pointer = { x: e.clientX, y: e.clientY }; top = false; root.querySelector('[data-rs-action="top"]').setAttribute('aria-pressed', 'false'); renderView(); });
      rug.addEventListener('pointerup', () => { pointer = null; });
      rug.addEventListener('pointercancel', () => { pointer = null; });
      rug.addEventListener('keydown', e => { if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','+','-'].includes(e.key)) return; e.preventDefault(); if (e.key === 'ArrowLeft') yaw -= 8; if (e.key === 'ArrowRight') yaw += 8; if (e.key === 'ArrowUp') tilt = clamp(tilt - 5, 0, 78); if (e.key === 'ArrowDown') tilt = clamp(tilt + 5, 0, 78); if (e.key === '+') zoom = clamp(zoom * 1.1, .6, 1.7); if (e.key === '-') zoom = clamp(zoom / 1.1, .6, 1.7); renderView(); });
      const animate = () => { if (!spin) return; yaw += .32; renderView(); animation = requestAnimationFrame(animate); };
      root.querySelectorAll('[data-rs-action]').forEach(button => button.addEventListener('click', () => {
        const action = button.dataset.rsAction;
        if (action === 'guide') { root.querySelector('[data-rs-dialog]').showModal(); return; }
        if (action === 'reset' || action === 'reset-all') { stopSpin(); yaw = -12; tilt = 58; zoom = 1; top = false; root.querySelector('[data-rs-action="top"]').setAttribute('aria-pressed', 'false'); if (action === 'reset-all') { colour = colours[0]; size = ''; renderSwatches(); renderSizes(); } }
        if (action === 'top') { top = !top; tilt = top ? 0 : 58; yaw = top ? 0 : -12; button.setAttribute('aria-pressed', String(top)); stopSpin(); }
        if (action === 'zoom-in') zoom = clamp(zoom * 1.15, .6, 1.7);
        if (action === 'zoom-out') zoom = clamp(zoom / 1.15, .6, 1.7);
        if (action === 'spin' && !reduced) { if (spin) stopSpin(); else { spin = true; button.setAttribute('aria-pressed', 'true'); button.textContent = 'Ⅱ'; animation = requestAnimationFrame(animate); } }
        renderView();
      }));
    }
    document.querySelectorAll('[data-rs-studio]').forEach(init);
    document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-rs-studio]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rugsone-portal-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let frame = 0;
    const clamp = (value) => Math.max(0, Math.min(1, value));
    const update = () => {
      frame = 0;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('[data-rp-hero]').forEach((root) => {
        const stage = root.querySelector('.rp-stage');
        if (!stage) return;
        const offset = parseFloat(getComputedStyle(root).getPropertyValue('--rp-sticky-offset')) || 0;
        const distance = Math.max(1, root.offsetHeight - stage.offsetHeight);
        const progress = reduced ? 1 : clamp((offset - root.getBoundingClientRect().top) / distance);
        root.style.setProperty('--rp-portal', `${18 + progress * 142}%`);
        root.style.setProperty('--rp-scale', `${1.12 - progress * .12}`);
        root.style.setProperty('--rp-intro', `${Math.max(0, 1 - progress * 2.2)}`);
        root.style.setProperty('--rp-outro', `${clamp((progress - .57) * 3.4)}`);
        root.style.setProperty('--rp-line', `${progress * 100}%`);
        const reveal = Math.max(0, Math.min(1, (progress - .08) / .78));
        root.style.setProperty('--rp-shift-left', `${-reveal * 100}%`);
        root.style.setProperty('--rp-shift-right', `${reveal * 100}%`);
        root.style.setProperty('--rp-sweep', `${(1 - reveal) * 100}%`);
        root.style.setProperty('--rp-glow-opacity', `${reveal > 0 && reveal < 1 ? 1 : 0}`);
        const intro = root.querySelector('.rp-intro');
        const outro = root.querySelector('.rp-outro');
        if (intro) intro.inert = progress > .49;
        if (outro) outro.inert = progress < .57;
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:select', (event) => {
      schedule();
      const root = event.target.matches?.('[data-rp-hero]') ? event.target : event.target.querySelector?.('[data-rp-hero]');
      if (root) {
        requestAnimationFrame(() => root.scrollIntoView({ block: 'start', behavior: 'instant' }));
        setTimeout(() => root.scrollIntoView({ block: 'start', behavior: 'instant' }), 160);
      }
    });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
